import resume from '../assets/pdf/resume.pdf'
import pp from './images/pp.png'






export const headerData = {
    name: 'Simrat Singh',
    tagline:'Dream.Build.Maintain',
    // title:"I'm a developer",
    desciption:"Embrace life's winding path with joy and anticipation, for it's in the journey, not the endpoint, that we truly flourish. Embrace every experience, learn from each, and savor the unique adventure of this one-time journey.",
    image: pp,
    resumePdf: resume,
    
}
